import React,{useEffect, useState} from 'react'
import { Grid2,Box, Paper, Typography} from '@mui/material'
import "../Products.css"
import { ProductCard } from '../../../components/Card/ProductCard'
import { productsData } from '../../../utils/constants'
import Link from '@mui/material/Link';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import HomeIcon from '@mui/icons-material/Home';

export function ProductsMobile() {
    const [value, setValue] =useState();
    const [allCategory,setAllCategory]=useState([])
  
    const handleChange = (event, newValue) => { setValue(newValue);};
  
    function handleClick(event) {
      event.preventDefault();
      console.info('You clicked a breadcrumb.');
    }
    
    useEffect(()=>{
      const allcategory=new Set([])
      productsData.map((item,i)=>{ allcategory.add(item.Category)})
      setAllCategory([...allcategory])
      setValue([...allcategory][0])
      },[])

  return (
    <Grid2>
    <Tabs component={Paper} elevation={8} value={value} onChange={handleChange} variant="scrollable" scrollButtons  sx={{backgroundColor:"#282A35",borderRadius:"0px",position:"sticky",top:"70px",zIndex:"999",".MuiTabScrollButton-root":{width:"15px !important",color:"#fff"},"& .Mui-selected": { backgroundColor: "green",color:"#fff !important"},"& .MuiTabs-indicator":{display:"none"},"& .Mui-disabled":{opacity:"1 !important"} ,minHeight:"30px",maxHeight:"30px"}} aria-label="scrollable force tabs example" allowScrollButtonsMobile>
    {allCategory.map((str,i)=><Tab component={Paper} elevation={8} sx={{color:"#fff",fontWeight:"600",padding:"0px",height:"15px",minHeight:"25px",maxHeight:"25px",fontSize:"12px",transition:".5s",margin:"2px",borderRadius:"5px"}} label={str} value={str} />)}          
    </Tabs>
    <Grid2 container sx={{justifyContent:"space-between",alignItems:"center",marginBottom:"10px",}}>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <Link underline="hover" key="1" color="inherit" href="/" onClick={handleClick} sx={{display:"flex",justifyContent:"center",alignItems:"center",fontSize:"12px !important"}}>  <HomeIcon align="center" sx={{fontSize:"18px"}}/> Home</Link>
          <Link underline="hover" key="2" color="inherit" href="/" onClick={handleClick} sx={{fontSize:"12px !important"}}>Products</Link>
          <Link underline="hover" key="3" color="inherit" href="/"  onClick={handleClick} sx={{fontSize:"12px !important"}}><span style={{ color:"#000",fontWeight:"700"}}>{value?.toUpperCase()}</span></Link>
        </Breadcrumbs>
        <Typography align='center'  sx={{fontSize:"15px",fontWeight:"600",color:"#154A72", flexGrow:"1",marginRight:"20%"}}>Products{" - "}<span style={{color:"green",fontFamily:"cursive"}}>{value?.toUpperCase()}</span></Typography>
      </Grid2>
    <Grid2 container className="info" spacing={0.5} justifyContent="flex-start" columns={20}  sx={{padding:"5px"}} >
      {productsData.map((item,i)=>{
        return( item.Category===value && <Grid2 size={{sm:6.5,xs:10}} key={i}><ProductCard itemData={item}/></Grid2>)
      })
      }
    </Grid2>
  </Grid2>
  )
}

 